// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__CqQPu","balanceDisclaimer":"posDashboard_balanceDisclaimer__1UcPh"};